var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-body"},[_c('b-container',{staticClass:"images"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"sm":"","md":"auto"}},_vm._l((_vm.images),function(img){return _c('img',{key:img,attrs:{"src":img}})}),0)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }